// extracted by mini-css-extract-plugin
export default {"AdSlotMail__mail":"bgf_a bhe_wj bhe_a bhe_q bhe_k","AdSlotMail__mail--notLoaded":"bgf_b bhe_ey bhe_bj bhe_wy","show-ad-not-loaded":"bgf_c","AdSlotMail__cta":"bgf_e"};